<template>
  <button
    :class="[
      'button',
      !disabled && variant,
      `size-${size}`,
      { disabled, pressed }
    ]"
    v-on="$listeners"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    tag: { type: String, default: "button" },
    variant: {
      type: String,
      validator: val =>
        ["default", "primary", "success", "danger", "warning"].includes(val),
      default: "default"
    },
    disabled: Boolean,
    pressed: Boolean,
    size: {
      type: String,
      validator: val => ["sm", "md", "lg"].includes(val),
      default: "md"
    }
  }
};
</script>

<style scoped lang="scss">
.button {
  --button-border-color: var(--button-default-border-color);
  --button-text-color: var(--button-default-text-color);
  --button-background: var(--button-default-background);
  --button-background-hover: var(--button-default-hover-background);
  --button-padding: calc(var(--button-padding-y) - 1px) var(--button-padding-x);

  box-sizing: border-box;
  display: inline-block;
  padding: var(--button-padding);
  margin: 0;
  font-size: var(--button-font-size);
  font-weight: var(--button-font-weight);
  line-height: 1rem;
  color: var(--button-text-color);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  background: var(--button-background);
  border: 1px solid var(--button-border-color);
  border-radius: 0.25rem;
  transition-duration: var(--animation-fast);
  transition-property: background-color;
  appearance: none;

  &:active,
  &.pressed {
    box-shadow: inset 0 0 0.25rem var(--shadow-color);
  }

  &:hover,
  &.pressed {
    background-color: var(--button-background-hover);
  }
}

.size-sm {
  --button-padding-x: 0.5rem;
  --button-padding-y: 0.25rem;
  --button-font-size: 0.8rem;
}

.size-md {
  --button-padding-x: 1rem;
  --button-padding-y: 0.5rem;
}

.size-lg {
  --button-padding-x: 1.5rem;
  --button-padding-y: 1rem;
}

.primary {
  --button-border-color: var(--button-primary-border-color);
  --button-text-color: var(--button-primary-text-color);
  --button-background: var(--button-primary-background);
  --button-background-hover: var(--button-primary-hover-background);
}

.danger {
  --button-border-color: var(--button-danger-border-color);
  --button-text-color: var(--button-danger-text-color);
  --button-background: var(--button-danger-background);
  --button-background-hover: var(--button-danger-hover-background);
}

.success {
  --button-border-color: var(--button-success-border-color);
  --button-text-color: var(--button-success-text-color);
  --button-background: var(--button-success-background);
  --button-background-hover: var(--button-success-hover-background);
}

.warning {
  --button-border-color: var(--button-warning-border-color);
  --button-text-color: var(--button-warning-text-color);
  --button-background: var(--button-warning-background);
  --button-background-hover: var(--button-warning-hover-background);
}

.disabled {
  --button-text-color: var(--button-disabled-text-color);
  --button-background: var(--button-disabled-background);
  --button-background-hover: var(--button-disabled-background);

  box-shadow: none;
}
</style>
